import { api } from "@/lib/api";
import type { AuditFilters, PlatformAuditLog } from "@/types/admin";

export interface PlatformAuditLogsResponse {
	data: PlatformAuditLog[];
	meta: {
		page: number;
		limit: number;
		total: number;
		totalPages: number;
		hasNext: boolean;
		hasPrev: boolean;
	};
}

// Audit API Service
export const auditService = {
	// Get platform-wide audit logs
	getPlatformAuditLogs: async (
		page = 1,
		limit = 50,
		filters?: AuditFilters,
	): Promise<PlatformAuditLogsResponse> => {
		const params = {
			page,
			limit,
			...filters,
		};

		const response = await api.get<PlatformAuditLogsResponse>(
			"/admin/audit",
			params,
		);
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to fetch audit logs");
		}
		return response.data.data as PlatformAuditLogsResponse;
	},
};
